import { LeafMark } from './Logo'
import { cn } from '../../lib/cn'

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn('inline-block h-6 w-6 animate-spin rounded-full border-2 border-current border-t-transparent', className)}
      role="status"
      aria-label="Loading"
    />
  )
}

/** Full-section branded loading state. */
export function LoadingScreen({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-ink-500" role="status" aria-live="polite">
      <LeafMark className="h-10 w-10 animate-pulse text-brand-500" />
      <span className="text-sm font-medium uppercase tracking-[0.2em]">{label}…</span>
    </div>
  )
}
